import React from 'react';
import { SDRDashboardTV } from '@/components/dashboard/SDRDashboardTV';
import { DashboardAccessGate } from '@/components/dashboard/DashboardAccessGate';
import { DashboardAccessNotificationProvider } from '@/components/dashboard/DashboardAccessNotificationProvider';

const SDRDashboard = () => {
  return (
    <DashboardAccessNotificationProvider>
      <DashboardAccessGate dashboardType="sdr">
        <SDRDashboardTV />
      </DashboardAccessGate>
    </DashboardAccessNotificationProvider>
  );
};

export default SDRDashboard;
